function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M16,21h15c0.552,0,1-0.447,1-1s-0.448-1-1-1H16c-0.552,0-1,0.447-1,1S15.448,21,16,21z",
  fill: "#9B9B9B"
}), React.createElement("path", {
  d: "M44,27H16c-0.552,0-1,0.447-1,1s0.448,1,1,1h28c0.552,0,1-0.447,1-1S44.552,27,44,27z",
  fill: "#9B9B9B"
}), React.createElement("path", {
  d: "M44,35H16c-0.552,0-1,0.447-1,1s0.448,1,1,1h28c0.552,0,1-0.447,1-1S44.552,35,44,35z",
  fill: "#9B9B9B"
}), React.createElement("path", {
  d: "M54,7h-1V4.793C53,2.195,50.805,0,48.207,0H11.793C9.195,0,7,2.195,7,4.793V7H6c-3.252,0-6,2.748-6,6v31 c0,3.252,2.748,6,6,6h14.555l8.702,9.669C29.446,59.88,29.716,60,30,60s0.554-0.12,0.743-0.331L39.445,50H54c3.252,0,6-2.748,6-6 V13C60,9.748,57.252,7,54,7z M9,4.793C9,3.279,10.279,2,11.793,2h36.414C49.721,2,51,3.279,51,4.793V7H9V4.793z M58,44 c0,2.168-1.832,4-4,4H41.462l2.313-2.289c0.393-0.389,0.396-1.021,0.007-1.414c-0.389-0.394-1.021-0.396-1.415-0.008l-4.011,3.969 c-0.031,0.027-0.072,0.041-0.1,0.073L30,57.505l-8.257-9.174c-0.006-0.007-0.016-0.009-0.022-0.016 c-0.007-0.008-0.01-0.018-0.017-0.026l-4.042-4c-0.393-0.388-1.025-0.386-1.415,0.008c-0.388,0.393-0.385,1.025,0.007,1.414 L18.568,48H6c-2.168,0-4-1.832-4-4V13c0-2.168,1.832-4,4-4h2h44h2c2.168,0,4,1.832,4,4V44z",
  fill: "#9B9B9B"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    version: 1.1,
    id: "Capa_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      "enableBackground": "new 0 0 60 60"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

export default __webpack_public_path__ + "static/media/comment-line.e242c213.svg";
export { SvgComponent as ReactComponent };